export function getEditorSize(csvOrigin, type) {
  const rows = Array.isArray(csvOrigin) ? csvOrigin.length : 0;
  const cols =
    rows > 0 && Array.isArray(csvOrigin[0]) ? csvOrigin[0].length : 0;

  if (rows === 480 && cols === 640) {
    return { width: 640, height: 480 };
  }

  // 640x435
  // thermal 신규 배열 크기
  if ((rows === 435 && cols === 640) || (rows === 640 && cols === 435)) {
    return { width: 640, height: 435 };
  }

  // 650x435
  // 기존 배열 크기 호환용
  if ((rows === 435 && cols === 650) || (rows === 650 && cols === 435)) {
    return { width: 650, height: 435 };
  }

  // 640x512
  if ((rows === 512 && cols === 640) || (rows === 640 && cols === 512)) {
    if (type === "thermal") {
      return { width: 640, height: 512 };
    }
    return { width: 640, height: 480 };
  }

  // fallback
  // thermal은 신규 기본값 640x435 사용
  if (type === "thermal") {
    return { width: 640, height: 435 };
  }

  // 기타 타입은 기존 레이아웃 유지
  return { width: 650, height: 435 };
}
